import { IonContent, IonModal } from "@ionic/react";
import { motion } from "motion/react";
import { Toolbar } from "./Toolbar";
import { BundleLine, Category, Product } from "@greeter/core";
import {
  PriceDisplay,
  VariantLibraryPicker,
  VariantLibraryPickerProps,
} from "./VariantLibraryPicker";
import { PickingFor } from "./BundlePickerMachineV3";

export type VariantLibraryModalProps = {
  isOpen?: boolean;
  onClose?: () => void;
  onPick?: VariantLibraryPickerProps["onPick"];

  pickingFor?: PickingFor;
  bundleLine?: BundleLine;
  products?: Array<Product>;
  categories?: Array<Category>;

  priceDisplay?: PriceDisplay;
};

export function VariantLibraryModal(props: VariantLibraryModalProps) {
  return (
    <IonModal isOpen={props.isOpen} onWillDismiss={props.onClose}>
      <Toolbar.Container>
        <Toolbar title="Vælg anden" onBack={props.onClose} />
      </Toolbar.Container>
      <IonContent>
        <motion.div
          key={"pickingFromVariantLibrary_" + props.bundleLine?.id}
          style={{
            backgroundColor: "var(--gm-color-default-bg)",
            maxWidth: "600px",
            margin: "auto",
          }}
        >
          <VariantLibraryPicker
            products={props.products ?? []}
            variants={props.bundleLine?.variants ?? []}
            categories={props.categories ?? []}
            pickingForVariantId={props.pickingFor?.variantId ?? ""}
            priceDisplay={props.priceDisplay}
            onPick={props.onPick}
          />
        </motion.div>
      </IonContent>
    </IonModal>
  );
}
